
export default function ServicesSection() {
  const services = [
    {
      icon: "ri-search-line",
      title: "茶叶选购咨询",
      description: "根据您的喜好、预算和用途，为您推荐最适合的茶叶产品",
      features: ["口感偏好分析", "品质等级选择", "价格区间匹配", "用途场景建议"],
      color: "from-[#cc9966] to-[#b8885a]"
    },
    {
      icon: "ri-graduation-cap-line",
      title: "茶艺培训指导",
      description: "从基础茶艺到高级品鉴，提供系统化的茶文化学习服务",
      features: ["冲泡技巧教学", "品鉴方法指导", "茶具使用培训", "茶文化传授"],
      color: "from-[#cc9966] to-[#b8885a]"
    },
    {
      icon: "ri-line-chart-line",
      title: "收藏投资建议",
      description: "专业的茶叶收藏与投资指导，帮您构建优质茶叶资产组合",
      features: ["市场趋势分析", "投资价值评估", "收藏策略制定", "风险控制建议"],
      color: "from-[#cc9966] to-[#b8885a]"
    },
    {
      icon: "ri-gift-line",
      title: "礼品定制服务",
      description: "为企业和个人提供茶礼定制，打造独特的茶文化礼品方案",
      features: ["礼品方案设计", "包装定制服务", "文化内涵植入", "批量采购优惠"],
      color: "from-[#cc9966] to-[#b8885a]"
    },
    {
      icon: "ri-hospital-line",
      title: "养生茶疗咨询",
      description: "结合中医理论，为您推荐适合的养生茶品和饮茶方案",
      features: ["体质分析诊断", "养生茶品推荐", "饮茶时机指导", "搭配方案建议"],
      color: "from-[#cc9966] to-[#b8885a]"
    },
    {
      icon: "ri-store-line",
      title: "茶馆经营指导",
      description: "为茶馆、茶楼等茶业经营者提供专业的运营咨询服务",
      features: ["选址建议指导", "产品组合规划", "运营模式设计", "营销策略制定"],
      color: "from-[#cc9966] to-[#b8885a]"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区域 */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            专业咨询服务
          </h2>
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            我们拥有资深的茶叶专家团队，为您提供全方位、专业化的茶叶咨询服务，
            让您在茶的世界里找到最适合的选择
          </p>
        </div>

        {/* 服务网格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              {/* 服务图标和标题 */}
              <div className="p-6 lg:p-8">
                <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-r ${service.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${service.icon} text-lg sm:text-xl md:text-2xl text-white`}></i>
                </div>
                
                <h3 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-bold text-[#663333] mb-4">
                  {service.title}
                </h3>
                
                <p className="text-xs sm:text-base text-gray-600 leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* 服务特色 */}
                <div className="space-y-3">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-[#cc9966] rounded-full"></div>
                      <span className="text-xs sm:text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* 底部CTA */}
              <div className="px-6 lg:px-8 pb-6 lg:pb-8">
                <button className="w-full py-3 bg-[#663333] text-white rounded-lg hover:bg-[#552929] transition-colors duration-300 font-semibold text-xs sm:text-sm whitespace-nowrap">
                  了解详情
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* 底部统计 */}
        <div className="mt-16 lg:mt-20 bg-[#663333] rounded-2xl p-8 lg:p-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 text-center">
            <div className="space-y-2">
              <div className="text-xl sm:text-3xl font-bold text-[#cc9966]">1000+</div>
              <div className="text-xs sm:text-base text-white opacity-90">服务客户</div>
            </div>
            <div className="space-y-2">
              <div className="text-xl sm:text-3xl font-bold text-[#cc9966]">98%</div>
              <div className="text-xs sm:text-base text-white opacity-90">满意度</div>
            </div>
            <div className="space-y-2">
              <div className="text-xl sm:text-3xl font-bold text-[#cc9966]">50+</div>
              <div className="text-xs sm:text-base text-white opacity-90">专业顾问</div>
            </div>
            <div className="space-y-2">
              <div className="text-xl sm:text-3xl font-bold text-[#cc9966]">24/7</div>
              <div className="text-xs sm:text-base text-white opacity-90">在线服务</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
